import './polyfills';

import { getConfigByHostname } from './getConfigByHostname';
import { launchBootstrap } from './launchBootstrap';
import { Win } from './Win';

export const launch = (window: Win) => {
    launchBootstrap({
        window,
        config: getConfigByHostname(window),
    });
};
